<script>
import { deepFind } from '@isyscore/utils/deep';

export default {
    name: 'ThePathTree',

    props: {
        menuList: {
            type: Array,
            // {id, title}
            default: () => []
        }
    },

    computed: {
        pageId() {
            return this.$route.query.pageId;
        }
    },

    methods: {
        async autoActive() {
            if (!this.menuList.length) return;

            let found, parentId;
            if (this.menuList[0].isLeaf) {
                found = { item: this.menuList[0] };
            } else {
                found = deepFind([this.menuList[0]], (item) => item.isLeaf);
                parentId = found.parent.id;
            }

            if (!found) return;

            const { id } = found.item;

            this.$emit('change', id.toString(), true);
            await this.activeMenu(id);

            if (parentId) this.$refs.menu.open(found.parent.id.toString());
        },

        async activeMenu(id) {
            await this.$nextTick();
            this.$refs.menu.activeIndex = id.toString();
        },

        onSelect(index) {
            this.$emit('change', index.toString());
        }
    },

    render(createElement, context) {
        const createMemu = (menuList, level) => {
            const menus = [];

            if (!menuList) return menus;

            menuList.forEach((menu) => {
                const { isLeaf } = menu;
                const compName = isLeaf ? 'li' : 'ul';

                menus.push(
                    createElement(
                        compName,
                        {
                            class: {
                                [`${compName}--${level}`]: true
                            },
                            props: {
                                index: menu.id.toString()
                            }
                        },
                        isLeaf ? [
                            createElement(
                                'a',
                                {
                                    staticClass: 'isc-menu-item__title text-truncate',
                                    slot: 'title',
                                    attrs: {
                                        'data-level': level,
                                        style: `--level:${level}`,
                                        title: menu.title,
                                        href: menu.refPageUrl
                                    }
                                },
                                menu.title
                            ),
                            ...createMemu(menu.children, level + 1)
                        ] : [
                            createElement(
                                'span',
                                {
                                    staticClass: 'isc-menu-item__title text-truncate',
                                    slot: 'title',
                                    attrs: {
                                        'data-level': level,
                                        style: `--level:${level}`,
                                        title: menu.title
                                    }
                                },
                                menu.title
                            ),
                            ...createMemu(menu.children, level + 1)
                        ]
                    )
                );
            });

            return menus;
        };

        return createElement(
            'div',
            {
                ref: 'menu',
                class: {
                    'the-menu': true
                },
                props: {
                    textColor: '#333'
                },
                on: {
                    select: this.onSelect
                }
            },
            createMemu(this.menuList, 1)
        );
    }
};
</script>

<style lang="scss" scoped>
.the-menu {
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    // height: 100%;
    // align-content: flex-start;
    padding-left: 20px;
    border-left: 1px dashed #6E95B7;
    ::v-deep {
        .isc-submenu.is-opened,
        .isc-submenu .isc-menu {
            background: #ededed;
        }

        .isc-menu-item,
        .isc-submenu {
            padding-left: 0;
        }

        .isc-submenu__title {
            padding: 0;
        }

        .isc-submenu.is-active .isc-submenu__title i {
            color: #333;
        }

        .isc-menu-item.is-active {
            background: #fff;
            background: linear-gradient(to right, rgba(4, 122, 255) 5%, rgba(255, 255, 255) 3%);
            color: #333;
        }

        .isc-menu-item .is-dot::after {
            background: #333;
        }

        .isc-menu-item__title {
            // margin-left: calc(15px + 20px * var(--level));
            // width: calc(100% - 15px - 20px * var(--level));
            display: inline-block;
        }

        .ul--1 {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            margin-bottom: 50px;
            align-content: space-around;
            padding-left: 200px;
            border-radius: 8px;
            box-shadow: 0px 4px 10px 0px rgba(73, 120, 177, 0.15);
            position: relative;
            span {
                width: 100%;
                margin-bottom: 20px;
                display: none;
                // background: #3796ff;
                // padding: 5px 0;
                // color: white;
                border-radius: 5px;
                // text-align: center;
                // font-size: calc(20px - 2px * var(--level));
            }
            &::before {
                width: 180px;
                content: "";
                left: 0;
                position: absolute;
                background-repeat: no-repeat;
                background-size: cover;
            }
            &::after {
                content: "";
                position: absolute;
                width: 20px;
                border-bottom: 1px dashed #6E95B7;
                left: -20px;
            }
            li {
                padding: 4px 14px 2px 14px;
            }
        }

        .ul--1:nth-child(1) {
            height: 148px;
            &::before {
                height: 148px;
                background-image: url('../../../../assets/images/map1.png');
            }
            &::after {
                top: 74px;
            }
            li {
                background: rgba(0, 118, 255, 0.04);
                border-radius: 17px;
                a {
                    color: #047AFF;
                }
            }
        }
        .ul--1:nth-child(2) {
            height: 200px;
            &::before {
                height: 200px;
                background-image: url('../../../../assets/images/map2.png');
            }
            &::after {
                top: 100px;
            }
            li {
                background: rgba(255, 156, 54, 0.04);
                border-radius: 17px;
                a {
                    color: #FF8100;
                }
            }
        }
        .ul--1:nth-child(3) {
            height: 164px;
            &::before {
                height: 164px;
                background-image: url('../../../../assets/images/map3.png');
            }
            &::after {
                top: 82px;
            }
            li {
                background: rgba(15, 186, 255, 0.04);
                border-radius: 17px;
                a {
                    color: #0097E3;
                }
            }
        }
        .ul--1:nth-child(4) {
            height: 200px;
            &::before {
                height: 200px;
                background-image: url('../../../../assets/images/map4.png');
            }
            &::after {
                top: 100px;
            }
            li {
                background: rgba(208, 109, 109, 0.04);
                border-radius: 17px;
                a {
                    color: #940000;
                }
            }
        }
        .ul--1:nth-child(5) {
            height: 200px;
            &::before {
                height: 200px;
                background-image: url('../../../../assets/images/map5.png');
            }
            &::after {
                top: 100px;
            }
            li {
                background: rgba(134, 125, 255, 0.04);
                border-radius: 17px;
                a {
                    color: #4033EE;
                }
            }
        }

        .ul--2 {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            
            span {
                width: 100%;
                margin-bottom: 5px;
                background: transparent;
                color: #333;
                text-align: left;
                padding: 0;
                display: block;
            }
        }
        li {
            margin-left: 20px;
            line-height: initial;
        }
    }
}
</style>
